export default "__VITE_ASSET__c54d70d6__"